module.exports = __webpack_public_path__ + "img/icon-done.8a4d0806.svg";